import React from 'react';
import {
  PaymentMethodType,
  CreditCard,
  TransactionAccount,
  PaymentOnTerms,
  Maybe,
} from '@css-xp/graphtypes/src/generated-types-new';
import { PaymentErrorLozenge } from '../../../copyable-text';
import { NoDataContentInTable } from '../../../no-data-content-table';

export interface PaymentMethodViewProps {
  invoiceGroupId: Maybe<string> | undefined;
  transactionAccount: Maybe<TransactionAccount>;
}

export const PaymentMethodView = ({ invoiceGroupId, transactionAccount }: PaymentMethodViewProps) => {
  let currentInvoiceGroupDetails;
  if (!invoiceGroupId) {
    currentInvoiceGroupDetails = transactionAccount?.availableInvoiceGroups?.nodes[0];
  } else {
    currentInvoiceGroupDetails = transactionAccount?.availableInvoiceGroups?.nodes?.find(
      (invoiceGroupObj) => invoiceGroupObj?.id === invoiceGroupId
    );
  }
  if (currentInvoiceGroupDetails?.defaultPaymentMethod) {
    if (currentInvoiceGroupDetails.defaultPaymentMethod?.type === PaymentMethodType.CARD) {
      const isPaymentIssue = currentInvoiceGroupDetails.defaultPaymentMethod?.paymentIssue === true;
      const creditCard = currentInvoiceGroupDetails.defaultPaymentMethod as CreditCard;
      return (
        <span>
          {`**** **** **** ${creditCard?.card?.last4Numbers ?? ''}`}
          {isPaymentIssue && (
            <>
              <br />
              <PaymentErrorLozenge />
            </>
          )}
        </span>
      );
    } else if (currentInvoiceGroupDetails.defaultPaymentMethod?.type === PaymentMethodType.DEFERRED) {
      const paymentOnTerms = currentInvoiceGroupDetails.defaultPaymentMethod as PaymentOnTerms;
      return <span>Payment on terms: due in {paymentOnTerms.terms?.invoiceDueDays} days</span>;
    }
  }
  return <NoDataContentInTable />;
};
